import { Injectable } from "@angular/core";
import { Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
// import { NativeStorage } from '@ionic-native/native-storage';
import firebase from 'firebase';
import { LocationDetails } from '../models/profile.model';

@Injectable()
export class LocationServices {
  constructor(
    public http: Http
  ) {}

  updateLocationData(profile): Promise<any> {

    var ref = firebase.database().ref('/users').child(profile.user.id);

    return new Promise((resolve,reject) => {
      ref.child('locationDetails').update(profile.locationDetails).then(response => {

        ref.child('locationHistory').push(profile.locationDetails);

        return resolve();
      })
      .catch(error =>{
        this.handleError(error);
      });
    });
  }

  findLocation(id): Promise<LocationDetails> {

    var ref = firebase.database().ref('/users').child(id);

    return new Promise((resolve, reject) => {

        ref.child('locationDetails').once('value', snapshot => {
            
            if(snapshot.val()){
                return resolve(snapshot.val())
            }

            return resolve();
        }, error => {
            this.handleError(error);
        });
    });
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// ./src/services/locationServices.ts